module.exports = __webpack_public_path__ + "static/media/image-card-6.26ee54ba.png";